<h2>
  {{ text1 }} <span class="highlighted">{{ text2 }}</span> {{ text3 }}
</h2>
<div class="row w100">
  <textarea
    [formControl]="control"
    [placeholder]="placeholder"
    [rows]="row"
    wrap="hard"
    [value]="textareaValue"
    (input)="onInput($event)"
    #textarea
  ></textarea>
  <div class="ai pointer">
    <rr-icon
      name="ai"
      *ngIf="aiIsRunning === false"
      [ngClass]="totalDiabledStatus === true ? 'disabled' : ''"
      (click)="startAiQuery()"
    ></rr-icon>
    <rr-icon
      name="ai"
      class="airunning"
      *ngIf="aiIsRunning === true"
      (click)="stopAiQuery()"
    ></rr-icon>
  </div>
</div>
<div
  class="agentrow space-between row gap-8 align-centerſ"
  *ngIf="showAgentRow === true"
>
  <rr-agent-select></rr-agent-select>
  <rr-icon name="pause"></rr-icon>
</div>
<div class="btnrow row space-between">
  <rr-btn
    type="Primary"
    [disabled]="totalDiabledStatus"
    (click)="next.emit(textarea.value)"
    >Next</rr-btn
  >
  <rr-btn type="Secondary" [disabled]="totalDiabledStatus" iconStart="ai"
    >Auto-fill for me</rr-btn
  >
</div>
<div
  class="suggestions col gap-12 w100"
  *ngIf="suggestions.length > 0 && showAgentSuggestions === true"
>
  <div
    class="suggestion row w100 gap-8 align-center pointer"
    *ngFor="let sug of suggestions"
    (click)="addSuggestionToTextarea(sug)"
  >
    <rr-icon name="ai"></rr-icon>
    <div class="suggestion_content">{{ sug.text }}</div>
  </div>
</div>
